import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=869be584&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=869be584&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869be584",
  null
  
)

export default component.exports